import type {ReactElement} from 'react';
import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import {GRID_ITEM_TYPE} from '@Components/base-grid/components/grid-item';
import {getStockFavoriteIdentity} from '@Panels/stock-panel/stock-favorites.library';
import {FavoriteButton} from './favorite-button';
import {FavoriteButtonVariant} from './favorite-button.types';

/**
 * The heart for a stock tile, or null for a tile that cannot be favorited. The audio card has no thumbnail
 * corner for the chip, so its heart is the bare one that joins the card's own row of actions.
 */
export const getStockFavoriteButtonForItem = (item: GridItemStorage): ReactElement | null => {
  const identity = getStockFavoriteIdentity(item);
  if (identity === null) {
    return null;
  }
  const variant = item.type === GRID_ITEM_TYPE.STOCK_AUDIO ? FavoriteButtonVariant.INLINE : FavoriteButtonVariant.MEDIA_OVERLAY;
  return <FavoriteButton identity={identity} variant={variant} />;
};
